import React, { createContext, useContext, useState } from "react";

interface IBreadcrumbsContext {
  breadcrumbs: { label: string; path: string }[];
  setBreadcrumbs: (breadcrumbs: { label: string; path: string }[]) => void;
}

const BreadcrumbsContext = createContext<IBreadcrumbsContext>({
  breadcrumbs: [],
  setBreadcrumbs: () => {},
});

export const useBreadcrumbs = () => useContext(BreadcrumbsContext);

export const BreadcrumbsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [breadcrumbs, setBreadcrumbs] = useState<
    { label: string; path: string }[]
  >([]);

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
